import { FILTER_TYPE_MULTI_SELECT } from "../components/UI/FilterChips/constants";

export const getFilters = (filter) => {
  // let filterCompanies = {
  //   field: "societyId",
  //   value: filter.filter((f) => f.field === "societyId").map((f) => f.filterValue),
  // };
  let filterData = filter
    // .filter((f) => f.field !== "societyId" && f.field !== "accidentPlace")
    .map((f) => {
      return {
        field: f.field,
        value: f.filterValue,
      };
    });
  // if (filterCompanies.value.length) {
  //   filterData.push(filterCompanies);
  // }
  return filterData;
};

export const getCompanyFilter = (user, t, selectedCountries) => {
  if (user.getCountries() && user.getCountries().length) {
    const countries = selectedCountries.length
      ? user.getCountries().filter((c) => selectedCountries.find((sc) => sc.filterValue === c.getId()))
      : user.getCountries();
    let companies = [];
    countries.forEach((c) => {
      companies = companies.concat(c.getCompanies());
    });
    return {
      field: "societyId",
      label: t("company"),
      filterType: FILTER_TYPE_MULTI_SELECT,
      options: companies.map((c) => {
        return {
          name: c.getDescription(),
          value: c.getId(),
        };
      }),
      directSelection: true,
    };
  }
  return null;
};

export const getCountryFilter = (user, t) => {
  if (user.getCountries() && user.getCountries().length) {
    const countries = user.getCountries();

    return {
      field: "countryId",
      label: t("country"),
      filterType: FILTER_TYPE_MULTI_SELECT,
      options: countries.map((c) => {
        return {
          name: c.getDescription(),
          value: c.getId(),
        };
      }),
      directSelection: true,
    };
  }
  return null;
};
export const setCompanyFilter = (user, t, filterOptions, setFilterOptions, selectedCountries) => {
  if (user.getCountries() && user.getCountries().length) {
    let newFilters = [...filterOptions];
    const companyFilter = getCompanyFilter(user, t, selectedCountries || []);
    const companyIndex = filterOptions.findIndex((f) => f.field === "societyId");
    if (companyIndex === -1) {
      newFilters.push(companyFilter);
    } else {
      newFilters[companyIndex] = companyFilter;
    }
    setFilterOptions(newFilters);
  }
};
export const setCountryFilter = (user, t, filterOptions, setFilterOptions) => {
  if (user.getCountries() && user.getCountries().length) {
    let newFilters = [...filterOptions];
    const countriesFilter = getCountryFilter(user, t);
    if (countriesFilter) {
      newFilters.push(countriesFilter);
    }
    const companyFilter = getCompanyFilter(user, t, []);
    if (companyFilter) {
      newFilters.push(companyFilter);
    }
    setFilterOptions(newFilters);
  }
};

export const equalCompanies = (companies1, companies2) => {
  let equal = true;
  companies1.forEach((c) => {
    if (equal && !companies2.find((c2) => c2.filterValue === c.filterValue)) {
      equal = false;
    }
  });
  if (equal) {
    companies2.forEach((c) => {
      if (equal && !companies1.find((c2) => c2.filterValue === c.filterValue)) {
        equal = false;
      }
    });
  }
  return equal;
};
